import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center px-4 py-32 text-center md:px-6 lg:px-10">
      <span className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-background-100 text-3xl text-primary-400">
        <i className="ri-moon-foggy-line"></i>
      </span>
      <p className="mb-2 font-heading text-5xl font-extrabold text-foreground-800 md:text-7xl">404</p>
      <h1 className="mb-3 font-heading text-2xl font-extrabold text-foreground-50">
        这一页没有放映
      </h1>
      <p className="mb-2 text-sm text-foreground-500">
        你访问的页面不存在或已被移除。
      </p>
      <p className="mb-8 font-mono text-xs text-foreground-700">{location.pathname}</p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-semibold text-foreground-200 transition-colors hover:border-primary-500 hover:text-primary-400"
        >
          浏览电影分类
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </div>
  );
}